<div class="pill-tabs" role="tablist">
    <button
        *ngFor="let tab of tabs; trackBy: trackById"
        type="button"
        role="tab"
        class="pill-tab"
        [class.active]="tab.id === activeId"
        [attr.aria-selected]="tab.id === activeId"
        (click)="selectTab(tab.id)">
        {{ tab.label }}
    </button>
</div>
